module.exports = __webpack_public_path__ + "img/bluecorona-logo-white.9f507c22.svg";